import { Card, CardContent, Typography } from "@mui/material";
import { Fragment } from "react";
import { Bills } from "./Bills";
import { useBillList } from "./hook/useBillList";
import { isAfter, subMonths } from "date-fns";
import { useTranslation } from "react-i18next";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";
import Divider from "@mui/material/Divider";

interface IParams {
    monthInterval: number;
    accountId: string;
}

export const BillsHistoryList = (props: IParams) => {
    const { monthInterval, accountId } = props;
    const { t } = useTranslation("bills");
    const { getBillListState, billList, errorMessage } = useBillList({ accountId });

    const dateLimit = subMonths(new Date(), monthInterval);
    const filteredBillList = billList.filter((bill) => {
        const billDate = new Date(bill.invoiceDate);

        return isAfter(billDate, dateLimit);
    });

    return (
        <Card elevation={2}>
            <CardContent>
                <HandleErrorAndLoading isLoading={getBillListState.isLoading}>
                    {filteredBillList.length > 0 &&
                        filteredBillList.map((bill, index) => (
                            <Fragment key={bill.invoiceNumber}>
                                <Bills
                                    accountId={accountId}
                                    amount={bill.amount}
                                    billDate={bill.invoiceDate}
                                    billNumber={bill.invoiceNumber}
                                />
                                {index !== filteredBillList.length - 1 && <Divider />}
                            </Fragment>
                        ))}
                    {filteredBillList.length === 0 && !getBillListState.error && (
                        <Typography align="center" color="secondary" variant="h5">
                            {t("noBill")}
                        </Typography>
                    )}
                    {getBillListState.error && (
                        <Typography align="center" color="secondary" variant="h5">
                            {errorMessage}
                        </Typography>
                    )}
                </HandleErrorAndLoading>
            </CardContent>
        </Card>
    );
};
